export function mobileAnnotationSize(width: number) {
  const font = Math.max(14, Math.min(18, (Number.isFinite(width) ? width : 320) / 24));
  return { font, radius: Math.max(10, Math.min(18, font)), padding: 24 };
}

export function readableAngle(angle: number) {
  const normalized = ((Number.isFinite(angle) ? angle : 0) % 360 + 360) % 360;
  return normalized > 90 && normalized < 270 ? normalized - 180 : normalized >= 270 ? normalized - 360 : normalized;
}

export function boundedLabel(value: number, extent: number, size: number) {
  return Math.max(4, Math.min(Math.max(4, extent - size - 4), value));
}
